// Hero.js
import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <motion.section 
      className="text-center py-16 px-6 flex flex-col items-center bg-custom-pattern"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <motion.h1 
        className="text-4xl md:text-6xl font-inter font-bold md:font-black text-acBlack leading-tight mt-8 md:mt-20"
        initial={{ opacity: 0, y: 20 }} 
        animate={{ opacity: 1, y: 0 }} 
        transition={{ duration: 1, delay: 0.3 }}
      >
        Your pathway to work, study,<br />and settle abroad.
      </motion.h1>
      
      <motion.p 
        className="text-lg text-gray-600 mt-4 max-w-3xl"
        initial={{ opacity: 0, y: 20 }} 
        animate={{ opacity: 1, y: 0 }} 
        transition={{ duration: 1, delay: 0.5 }}
      >
        We help individuals navigate eligibility, documents, filings, and interviews across the US, Canada, UK, EU/Germany, Australia, and the UAE.
      </motion.p>
      
      <motion.div 
        className="mt-8 flex flex-col sm:flex-row items-center gap-4"
        initial={{ opacity: 0, scale: 0.8 }} 
        animate={{ opacity: 1, scale: 1 }} 
        transition={{ duration: 0.6, delay: 0.8 }}
      >
        <Link to="/contact" className="bg-blue-600 hover:bg-blue-800 text-white font-semibold px-8 py-3 rounded-lg transition-colors">
          Check your eligibility
        </Link>
        <Link to="/contact" className="text-blue-600 hover:text-blue-800 font-medium underline transition-colors">
          Book a consultation
        </Link>
      </motion.div>
      
      {/* <motion.p 
        className="text-xs text-gray-500 mt-3 max-w-md text-center"
        initial={{ opacity: 0, y: 10 }} 
        animate={{ opacity: 1, y: 0 }} 
        transition={{ duration: 0.8, delay: 1 }}
      >
        General guidance only, not legal advice. Where required, we coordinate with licensed local counsel.
      </motion.p> */}
      
      <motion.div 
        className="flex flex-wrap justify-center items-center gap-4 mt-8"
        initial={{ opacity: 0, y: 20 }} 
        animate={{ opacity: 1, y: 0 }} 
        transition={{ duration: 1, delay: 1.2 }}
      >
        <div className="bg-blue-50  text-blue-700 px-3 py-1 rounded-full text-sm font-medium">
          24–72h response
        </div>
        <div className="text-gray-600 text-sm">
          6 core services: <span className="font-medium">Work • Study • Family • PR • Investor • Visit</span>
        </div>
      </motion.div>
    </motion.section>
  );
};

export default Hero;
